module.exports = __webpack_public_path__ + "static/media/Dbl_Chevron_Left.26ac7065.svg";